import Glide from '@glidejs/glide'

export default class PoolCollection extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    new Glide('.glide').mount()
  }
}

customElements.define('pool-collection', PoolCollection)
